import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { resolveTenantUrl, tenantOverrideOptions } from "src/app/Common/ApiConfigurationService/resolve-tenant-url.util";
import {
    RolesUpdateRequest,
    RolesCreateRequest,
    RolesDeleteRequest,
    RolesReadByGroupNameRequest,
    RolesReadAllPaginatedRequest,
    RolesList,
    RolesDTO,
    RolesReadByTenantIdRequestDTO ,
    RolesGetDictionaryResponse,

} from './roles.interface';
import {
    Roles_create,
    Roles_update,
    Roles_delete,
    Roles_readAllPaginated,
    Roles_readByGroupName,
    Roles_getDictionary,
    Roles_readByTenantId
} from 'src/app/GlobalVariables';
import { GetDictionaryList } from "src/app/Common/common.interface";

@Injectable({
    providedIn: 'root'
})

export class RolesService {

    constructor() { }

    http = inject(HttpClient);

    Roles_create(data: RolesCreateRequest): Observable<RolesCreateRequest> {
        return this.http.post<RolesCreateRequest>(Roles_create, data);
    }

    Roles_update(data: RolesUpdateRequest): Observable<RolesUpdateRequest> {
        return this.http.post<RolesUpdateRequest>(Roles_update, data);
    }

    Roles_delete(data: RolesDeleteRequest): Observable<RolesDeleteRequest> {
        return this.http.post<RolesDeleteRequest>(Roles_delete, data);
    }

    // baseUrlOverride/companyId/branchId (all optional, read methods only):
    // Roles does NOT actually work routed via the Identity Server (confirmed
    // live, 2026-09-25 - despite being listed as identity-domain in
    // IDENTITY-SERVER-DESIGN.md), so this routes directly to the viewed
    // tenant's own gateway with that tenant's own CompanyId/BranchId headers,
    // e.g. CompanyDetailComponent.apiConfigOverride.am on the Customer
    // Details page's Roles tab. Omitted/undefined for every other caller of
    // this shared root service - behaves exactly as before.
    Roles_readAllPaginated(data: RolesReadAllPaginatedRequest, baseUrlOverride?: string, companyId?: string | number, branchId?: string | number): Observable<RolesList> {
        return this.http.post<RolesList>(resolveTenantUrl(Roles_readAllPaginated, baseUrlOverride), data, tenantOverrideOptions(baseUrlOverride, companyId ?? 0, branchId ?? 0));
    }

    Roles_readByGroupName(data: RolesReadByGroupNameRequest, baseUrlOverride?: string, companyId?: string | number, branchId?: string | number): Observable<RolesReadByGroupNameRequest> {
        return this.http.post<RolesReadByGroupNameRequest>(resolveTenantUrl(Roles_readByGroupName, baseUrlOverride), data, tenantOverrideOptions(baseUrlOverride, companyId ?? 0, branchId ?? 0));
    }

    Roles_getDictionary(data: { actionUser: string }, baseUrlOverride?: string, companyId?: string | number, branchId?: string | number): Observable<GetDictionaryList> {
        return this.http.post<GetDictionaryList>(resolveTenantUrl(Roles_getDictionary, baseUrlOverride), data, tenantOverrideOptions(baseUrlOverride, companyId ?? 0, branchId ?? 0));
    }

    Roles_readByTenantId(data: RolesReadByTenantIdRequestDTO, baseUrlOverride?: string, companyId?: string | number, branchId?: string | number): Observable<RolesGetDictionaryResponse> {
        return this.http.post<RolesGetDictionaryResponse>(resolveTenantUrl(Roles_readByTenantId, baseUrlOverride), data, tenantOverrideOptions(baseUrlOverride, companyId ?? 0, branchId ?? 0));
    }

}
